export const orderModule = {
    cancel: "取消",
    pay: "支付",
    chose_pay_type:"请选择支付方式",
    phone:"手机号",
    desc1:"将门票URL发送到以下手机号码或者Email",
    pay_title:"支付",
    to_pay:"去支付",
    agree:"同意",
    policy:"隐私政策",
    total:"合计",
    use_point:"利用景点",
    use_point_code:"使用时请扫二维码",
    code:"对照码",
    used_point:"已经利用的景点",
    more:"更多",
    input:"请填写必要信息",
    pay_type:"请选择支付方式",
    isCancel:"要取消吗?",
    sure:"确定",
    pay_success:"感谢您的购买",
    pay_cancel:"成功取消",
    pay_fail:"支付失败",
    pay_cancel1:"已取消",
    pay_wait:"支付结果等待中",
    status1:"等待支付",
    status2:"可以使用",
    status3:"已完成",
    status4:"已过期",
    status5:"已退款",
    status6:"取消",
    selectBookFun: "选择方式",
    inputBookPlaceholder: "请输入发票的抬头",
    inputMemoPlaceholder: '请填写备注',
    getBook: "发票抬头",
    comment: "评论",
    comment_star: "满足度",
    comment_contentHolder: "请留言",
    comment_noStar: "请选择满意度",
    comment_noContent: "评论内容不能为空",
    comment_submitSuccess: "评价成功",
    comment_replay: "商家回复",
    comment_uploadSuccess: "上传成功",
    comment_moreImg: "最多可以上传4张图片",
    comment_sizeImg: "图片不能大于5M",
};

export default orderModule;